
import { defineComponent } from '@nuxtjs/composition-api'
import ErrorSerializer from '~/serializer/Error'
import type ProductAPI from '~/api/product.api'

type ResponseType = Awaited<ReturnType<typeof ProductAPI.getByID>>['result']

export default defineComponent({
  async asyncData({ app, params, $pageError, route, error }) {
    try {
      const response = (
        await app.$api.product.getByID({
          id: params.id,
        })
      )?.result

      /**
       * По умолчанию, при переходе по роуту который содержит дублирующие значения /catalog/catalog/portativ/portativ/phones//phones/145291/145291/question/
       * страница загружается, и возвращает код 200. По таким роутам должен происходить редирект на 404 страницу.
       * Поэтому приводим роуты с адресной строки и с апи к одинаковому виду, и сравниваем. Если они не равны, редиректим на 404
       */
      const routeFormatted = route.fullPath.match(/\/(catalog.*?\/\d+)\//)?.[0]

      if (routeFormatted !== response.product.path)
        error({ statusCode: 404, message: 'Товар не найден' })

      return { response }
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new $pageError({
        ...error,
        message: error.code === 404 ? 'Товар не найден' : error.message,
      })
    }
  },
  data(): {
    response: ResponseType
  } {
    return {
      response: {} as ResponseType,
    }
  },
})
